import { inject, InjectionToken, computed } from '@angular/core';
import {
  signalStore,
  withState,
  withComputed,
  withMethods,
  patchState,
  withProps,
  WritableStateSource,
} from '@ngrx/signals';
import { rxMethod } from '@ngrx/signals/rxjs-interop';
import { ResourceService } from '../services/resource.service';
import { ResourceState } from '../types';
import { pipe, switchMap, filter } from 'rxjs';
import { tapResponse } from '@ngrx/operators';

export const RESOURCE_INITIAL_STATE = new InjectionToken<ResourceState>(
  'Resources Initial State',
  {
    factory: () => ({
      resources: [],
      isLoading: true,
    }),
  },
);

const _fetchResources = (
  store: WritableStateSource<ResourceState>,
  _resourceService: ResourceService,
) =>
  rxMethod<void>(
    pipe(
      switchMap(() =>
        _resourceService.getResources().pipe(
          filter((response) => !!response),
          tapResponse(
            (response) => {
              patchState(store, {
                resources: response,
                isLoading: false,
              });
            },
            (error) => {
              console.error('Error:', error);
              patchState(store, { isLoading: false });
            },
          ),
        ),
      ),
    ),
  );
export const RESOURCE_SIGNAL_STORE = signalStore(
  withState(() => inject(RESOURCE_INITIAL_STATE)),
  withProps((store) => ({
    _resourceService: inject(ResourceService),
    store,
  })),
  withComputed((store) => ({
    $resources: computed(() => {
      return store.resources();
    }),
  })),
  withMethods(({ store, _resourceService }) => {
    return {
      fetchResources: _fetchResources(store, _resourceService),
    };
  }),
);
